import { getCmsEnahancedTripDetailBySlug } from "../../../app/api/getCmsEnahancedTripDetailBySlug";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { ICmsEnhancedTripResponse, ICmsEnhancedTrips, IGetEnhancedTripActionParams } from "../../../Orchestrator/Types/Interface/ICmsEnhancedTrip";

class GetCmsEnhancedTripDetailAction extends BaseAction<
  ICmsEnhancedTrips[],
  IGetEnhancedTripActionParams
> {
  override async run(): Promise<ICmsEnhancedTrips[] | null> {
    let enhancedTripDetail: ICmsEnhancedTrips[] | null = null;
    try {
      const { slug } = this.params!;
      const response: IApiResponse<ICmsEnhancedTripResponse> = await getCmsEnahancedTripDetailBySlug(slug);
      if (response.status === "ok" && response.answer) {
        const enhancedTrip = response.answer.data;
        if (enhancedTrip.length > 0) {
          enhancedTripDetail = enhancedTrip;
          updateRecoilState("enhancedTripDetailAtom", enhancedTripDetail);
        } else {
          updateRecoilState("enhancedTripDetailAtom", null);
          console.warn("No enhanced trips available.");
        }
      } else {
        console.warn("Failed to fetch enhanced trips.");
      }
    } catch (error: any) {
      console.error("Error fetching enhanced trips:", error);
    } finally {
      return enhancedTripDetail;
    }
  }
}

export const getCmsEnhancedTripDetailAction = new GetCmsEnhancedTripDetailAction();
